import { BitrixVue } from 'ui.vue';

BitrixVue.cloneComponent('Step13', 'Steps', {
	data() {
		return {
			step: null,
			activeRadio: 0,
		};
	},
	props: [],
	created() {
		this.getDataStep();
	},
	methods: {
		getDataStep: function () {
			let context = this;
			let store = { ...this.$store.state.position };
			delete store.renderImage;
			let req = BX.ajax.runComponentAction('mworks:configurator', 'getDataStep13', {
				mode: 'class',
				method: 'post',
				data: {
					position: store,
				},
			});

			req.catch(function (response) {
			});

			req.then((response) => {
				if (response.status == 'success') {
					context.step = response.data.result;
					context.setPropPosition({ slatPlankStatus: context.step.slatPlank[context.activeRadio] });
				}
			});
		},
		setActiveRadio(value) {
			this.activeRadio = value;
		},
		isDataStep: function () {
			return this.step;
		},
	},
	watch: {
		activeRadio: function (val) {
			const activeSlankItem = this.step.slatPlank.filter((item) => {
				if (item.value === val) {
					return item;
				}
			});
			if (activeSlankItem.length) {
				this.setPropPosition({ slatPlankStatus: activeSlankItem });
			} else {
				context.deletePositionKey(['slatPlankStatus']);
			}
		},
	},
	template: `
<div class="config-block" v-if="isDataStep()">
		<div class="config-block__inner">
			<div class="config-block__wrap">
				<ConfigBlockWrapTitle :tippyContent="step.slatPlankTippy">Притворная планка</ConfigBlockWrapTitle>
				<RadioGroup :options="step.slatPlank" name="slat_plank_price"
					v-on:selectedValue="setActiveRadio" />
			</div>
		</div>
	</div>
`,
});
